exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".catch-item[data-v-6c89580c]{background:var(--base-color)!important}", ""]);

// exports
